import { NonIndexRouteObject } from 'react-router';

import { HomeRoutes } from '../../../../../RouteConstants';
import { LoadingIndicator } from '@components/LoadingIndicatorMaterial';
import { RouteErrorPage } from '@components/ErrorBoundary';

export const DBLoginPublicRoutes: NonIndexRouteObject[] = [
  {
    id: 'db-login',
    path: HomeRoutes.login,
    hydrateFallbackElement: <LoadingIndicator isLoading />,
    errorElement: <RouteErrorPage />,
    async lazy() {
      const HomeLayoutLoginRoutes = (
        await import('../../../../../../Modules/Home/HomeLayouts/HomeLayoutLoginRoutes')
      ).default;
      const Login = (await import('../../../../../../Modules/Authentication/Login/Login')).default;
      const { LoginAction } = await import(
        '../../../../../../Modules/Authentication/Login/utils/login.action'
      );
      return {
        element: <HomeLayoutLoginRoutes content={<Login isAdminLogin={false} />} />,
        errorElement: <RouteErrorPage />,
        action: LoginAction,
      };
    },
  },
  {
    path: HomeRoutes.confirmSignUp,
    hydrateFallbackElement: <LoadingIndicator isLoading />,
    errorElement: <RouteErrorPage />,
    async lazy() {
      const HomeLayoutLoginRoutes = (
        await import('../../../../../../Modules/Home/HomeLayouts/HomeLayoutLoginRoutes')
      ).default;
      const ConfirmSignUp = (
        await import('../../../../../../Modules/Authentication/ConfirmSignup/ConfirmSignup')
      ).default;
      const { ConfirmSignUpAction } = await import(
        '../../../../../../Modules/Authentication/ConfirmSignup/utils/confirmSignup.action'
      );

      return {
        element: <HomeLayoutLoginRoutes content={<ConfirmSignUp />} />,
        errorElement: <RouteErrorPage />,
        action: ConfirmSignUpAction,
      };
    },
  },
  {
    path: HomeRoutes.forgotPassword,
    hydrateFallbackElement: <LoadingIndicator isLoading />,
    errorElement: <RouteErrorPage />,
    async lazy() {
      const HomeLayoutLoginRoutes = (
        await import('../../../../../../Modules/Home/HomeLayouts/HomeLayoutLoginRoutes')
      ).default;
      const ForgotPassword = (
        await import('../../../../../../Modules/Authentication/ForgotPassword/ForgotPassword')
      ).default;
      const { ForgotPasswordAction } = await import(
        '../../../../../../Modules/Authentication/ForgotPassword/utils/forgotPassword.action'
      );

      return {
        element: <HomeLayoutLoginRoutes content={<ForgotPassword />} />,
        errorElement: <RouteErrorPage />,
        action: ForgotPasswordAction,
      };
    },
  },
];
